var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"hide-on-print",attrs:{"icon":"","color":"black","to":_vm.backRoute},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("mdi-arrow-u-left-top")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }